import * as React from "react"
import { MarqueeButton, CustomStylesButtonProps } from "../../../common/buttons"
import { BuyButtonProps } from "../badges.interface"
import { brandingSelector } from "../../../../recoil/atoms/room"
import { useRecoilValue } from "recoil"

const BadgeButton: React.FC<BuyButtonProps> = ({
  handleClick,
  textButton,
  customStyles = {}
}) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const { _hoverStyles, ...otherStyles } = customStyles
  const customStylesMarqueeButton =
    React.useMemo<CustomStylesButtonProps>(() => {
      return {
        button: {
          fontFamily: roomStyles?.badgeButtonFontFamily ?? "inherit",
          background: roomStyles.badgeButtonBackgroundColor ?? "#EDF2F7",
          borderColor: roomStyles?.badgeButtonBorderColor ?? "#e2e8f0",
          color: roomStyles?.badgeButtonTextColor ?? "#718096",
          maxWidth: "100px",

          _hoverStyles: {
            color: `${
              roomStyles?.badgeButtonMouseoverTextColor ?? "#000"
            }  !important`,
            background: `${
              roomStyles?.badgeButtonMouseoverBackgroundColor ?? "#edf2f7"
            }  !important`,
            ..._hoverStyles
          },
          ...otherStyles
        },
        textButton: {
          maxWidth: "100px",
          padding: "0px 10px"
        }
      }
    }, [
      _hoverStyles,
      otherStyles,
      roomStyles.badgeButtonBackgroundColor,
      roomStyles?.badgeButtonBorderColor,
      roomStyles?.badgeButtonFontFamily,
      roomStyles?.badgeButtonMouseoverBackgroundColor,
      roomStyles?.badgeButtonMouseoverTextColor,
      roomStyles?.badgeButtonTextColor
    ])

  return (
    <MarqueeButton
      onClick={handleClick}
      textButton={textButton}
      customStyles={customStylesMarqueeButton}
    />
  )
}

export default BadgeButton
